import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../hook/auth";
import { logoutAPI } from "../api/authAPI";
import styled, { css } from "styled-components";
import { Button, Dropdown, Menu } from "antd";
import { LogoutOutlined, MenuOutlined, UserOutlined } from "@ant-design/icons";
import { useMediaQuery } from "../utils/mediaQueries";

const NavbarContainer = styled.nav`
  width: 100%;
  height: 100%;
  display: flex;
  background-color: #e4e4e4;
  justify-content: space-between;
  padding: auto;
  padding-left: 50px;
  padding-right: 50px;
`;

const Logo = styled.h1`
  margin: auto 0;
  font-size: 2rem;
  font-weight: bold;
  cursor: pointer;

  ${({ isActive }) =>
    isActive &&
    css`
      opacity: 1;
      color: #1890ff;
    `}

  &:hover {
    opacity: 0.8;
    color: #1890ff;
  }
`;

const MenuList = styled.ul`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  list-style-type: none;
  padding: 0;
`;

const MenuItem = styled.li`
  cursor: pointer;
  color: #000000;
  /* font-size: 1rem; */
  transition: all 0.3s;

  ${({ isActive }) =>
    isActive &&
    css`
      opacity: 1;
      color: #1890ff;
    `}

  &:hover {
    opacity: 0.8;
    color: #1890ff;
  }
`;

const LogoutButton = styled(Button)`
  width: 100px;
  cursor: pointer;

  ${({ isActive }) =>
    isActive &&
    css`
      opacity: 1;
      color: #1890ff;
    `}

  &:hover {
    opacity: 0.8;
    color: #1890ff;
  }
`;

const Navbar = () => {
  const { isAuthenticated, role } = useAuth();
  const user = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const isMobile = useMediaQuery("(max-width: 1100px)");

  const handleLogout = async () => {
    await logoutAPI(user._id);
  };

  const handleLogin = () => {
    navigate("/login");
  };

  const handleMenuClick = ({ key }) => {
    if (key === "logout") {
      handleLogout();
    }
  };

  const menu = (
    <Menu onClick={handleMenuClick}>
      {isAuthenticated ? (
        <Menu.Item key="logout" danger icon={<LogoutOutlined />}>
          Logout
        </Menu.Item>
      ) : (
        <>
          <LogoutButton
            onClick={handleLogin}
            isActive={window.location.pathname === "/login"}
          >
            Login
          </LogoutButton>
        </>
      )}
    </Menu>
  );

  const burgerMenu = [
    {
      key: "1",
      label: (
        <MenuItem
          isActive={window.location.pathname === "/"}
          onClick={() => navigate("/")}
        >
          Laman Utama
        </MenuItem>
      ),
    },
    {
      key: "2",
      label: (
        <MenuItem
          isActive={window.location.pathname === "/propertyListings"}
          onClick={() => navigate("/propertyListings")}
        >
          Senarai Hartanah
        </MenuItem>
      ),
    },
    {
      key: "3",
      label: (
        <MenuItem
          isActive={window.location.pathname === "/soldListings"}
          onClick={() => navigate("/soldListings")}
        >
          Hartanah Terjual
        </MenuItem>
      ),
    },
    {
      key: "4",
      label: (
        <MenuItem
          isActive={window.location.pathname === "/propertyEvaluation"}
          onClick={() => navigate("/propertyEvaluation")}
        >
          Semak Nilai Hartanah
        </MenuItem>
      ),
    },
    {
      key: "5",
      label: (
        <MenuItem
          isActive={window.location.pathname === "/borang"}
          onClick={() => navigate("/borang")}
        >
          Borang
        </MenuItem>
      ),
    },
    role === "admin" && {
      key: "6",
      label: (
        <MenuItem
          isActive={window.location.pathname === "/createPost"}
          onClick={() => navigate("/createPost")}
        >
          Reka Post
        </MenuItem>
      ),
    },
    role === "admin" && {
      key: "7",
      label: (
        <MenuItem
          isActive={window.location.pathname === "/propertyDataList"}
          onClick={() => navigate("/propertyDataList")}
        >
          Haratanah Editor
        </MenuItem>
      ),
    },
    {
      key: "8",
      label: (
        <MenuItem
          isActive={window.location.pathname === "/contact"}
          onClick={() => navigate("/contact")}
        >
          Contact
        </MenuItem>
      ),
    },
  ];

  return (
    <NavbarContainer>
      <Logo
        onClick={() => navigate("/")}
        isActive={window.location.pathname === "/"}
      >
        AY
      </Logo>
      {!isMobile ? (
        <MenuList>
          <MenuItem
            isActive={window.location.pathname === "/"}
            onClick={() => navigate("/")}
          >
            Laman Utama
          </MenuItem>
          <MenuItem
            isActive={window.location.pathname === "/propertyListings"}
            onClick={() => navigate("/propertyListings")}
          >
            Senarai Hartanah
          </MenuItem>
          <MenuItem
            isActive={window.location.pathname === "/soldListings"}
            onClick={() => navigate("/soldListings")}
          >
            Hartanah Terjual
          </MenuItem>
          <MenuItem
            isActive={window.location.pathname === "/propertyEvaluation"}
            onClick={() => navigate("/propertyEvaluation")}
          >
            Semak Nilai Hartanah
          </MenuItem>
          <MenuItem
            isActive={window.location.pathname === "/borang"}
            onClick={() => navigate("/borang")}
          >
            Borang
          </MenuItem>
          {role === "admin" && (
            <>
              <MenuItem
                isActive={window.location.pathname === "/createPost"}
                onClick={() => navigate("/createPost")}
              >
                Reka Post
              </MenuItem>
              <MenuItem
                isActive={window.location.pathname === "/propertyDataList"}
                onClick={() => navigate("/propertyDataList")}
              >
                Haratanah Editor
              </MenuItem>
            </>
          )}
          <MenuItem
            isActive={window.location.pathname === "/contact"}
            onClick={() => navigate("/contact")}
          >
            Contact
          </MenuItem>
        </MenuList>
      ) : (
        <div>
          <Dropdown
            menu={{ items: burgerMenu }}
            placement="bottom"
            trigger={["click"]}
          >
            <Button ghost shape="circle">
              <MenuOutlined />
            </Button>
          </Dropdown>
        </div>
      )}
      <div>
        <Dropdown overlay={menu} trigger={["click"]}>
          <Button ghost shape="circle">
            <UserOutlined />
          </Button>
        </Dropdown>
      </div>
    </NavbarContainer>
  );
};

export default Navbar;
